export const LOGIN_CONST = {
    FORM: {
        TITLE: 'Вхід до системи',
        EMAIL_FIELD_LABEL: 'Електронна пошта',
        PASSWORD_FIELD_LABEL: 'Пароль',
        SUBMIT_BUTTON: 'Увійти',
    },

    ERROR_MODAL: {
        TITLE: 'Помилка входу',
        CONTENT: 'Неправильний логін або пароль',
        BUTTON: 'OK',
    },
};
